<div class="layout-wrapper">
  <app-header (toggleSidebar)="toggleSidebar()"></app-header>
  <mat-sidenav-container class="layout-body" [hasBackdrop]="false">
    <mat-sidenav
      [opened]="sidebarOpen"
      [mode]="sidebarMode"
      class="sidebar"
      (openedChange)="sidebarOpen = $any($event)"
    >
      <app-sidebar-menu [menuConfig]="menuConfig"></app-sidebar-menu>
    </mat-sidenav>
    <mat-sidenav-content class="content">
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
    <mat-sidenav
      position="end"
      mode="over"
      class="alio-sidenav"
      [class.alio-resizing]="isResizingAlio"
      [style.width.px]="alioDrawer.width$ | async"
      [opened]="alioDrawer.isOpen$ | async"
      (openedChange)="onAlioOpenedChange($event)"
    >
      <div class="alio-resize-handle" (pointerdown)="startAlioResize($event)"></div>
      <app-alio-drawer></app-alio-drawer>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
